export const giphyApiKey = 'NaRMRUiI9uJEKFSLwEvwGNtSjhVcWdvo'